



























































































































































































































































































import axios from 'axios';
import { format } from 'date-fns';
import {
  DataCoreSvcFeedhdlFeedValidationOutput,
  // DataCoreSvcFeedhdlGetLatestValidationErrorsOutput was removed from the generated types
  // DataCoreSvcSyncconfirmationsEntitySyncSummary was also removed from the generated types
  // Using DataCoreSvcFeedhdlFeedValidationOutput for validation results
} from 'generated/data-core-svc';
import { Component, Vue } from 'vue-property-decorator';

import DataApiManager from '@/api/dataCoreApiManager';
import { BaseVue } from '@/BaseVue';
import UiButton from '@/components/ui/UiButton.vue';
import UiLoading from '@/components/ui/UiLoading.vue';
import UiModal from '@/components/ui/UiModal.vue';
import UiPageHeader from '@/components/ui/UiPageHeader.vue';

import { feedRunStartErrorMessage } from './DataImportUtils';

// Add type declaration for $toasted
declare module 'vue/types/vue' {
  interface Vue {
    $toasted: {
      success(msg: string): void;
      error(msg: string): void;
      info(msg: string): void;
      warning(msg: string): void;
    };
  }
}

// Define a replacement interface for the missing type
interface EntitySyncSummary {
  entityId: string;
  entityType: string;
  syncStatus: string;
  lastSyncTime?: string;
  errorMessage?: string;
}

@Component({
  components: {
    UiButton,
    UiLoading,
    UiPageHeader,
    UiModal,
  },
})
export default class FeedDetail extends BaseVue {
  // Define interface for feed data to fix type errors
  public feed: {
    feedId: string;
    name: string;
    description: string;
    dataSourceId: string;
    cronExpression: string;
    status: string;
    configuration: any;
    createdBy: { principalId: string };
    createdAt: string;
    updatedBy: { principalId: string };
    updatedAt?: string;
    feature: string;
    entityType: string;
    approvalStatus: string;
    knownSchemaId: string;
    immutableDataSourceSchemaHash: string;
    orgId: string;
  } | null = null;

  // Feed run data
  public feedRuns: any[] = [];
  public feedRunErrors: any[] = [];
  public feedRunErrorMessage: string | null = null;
  public showDeleteModal = false;
  public error: string | null = null;
  public dataSources: any[] = [];

  // Loading states
  private isLoading = true;
  private isLoadingFeedRuns = false;
  private isLoadingFeedRunErrors = false;
  private isLoadingDataSource = false;
  private isCheckingForErrors = false;
  private isDownloading = false;
  private isStartFeedLoading = false;
  private isDeleting = false;

  get feedId(): string {
    return this.$route.params.id;
  }

  async mounted() {
    console.log('🔍 FeedDetail component MOUNTED');

    // Set initial states
    this.isLoadingFeedRunErrors = true;

    // Load all necessary data - only make the essential API calls on mount
    await Promise.all([
      this.loadFeedDetails(), // This will load sync summary which will load feed runs
      this.loadDataSources(),
    ]);

    // Don't automatically load feed run errors - wait for user to click "View Errors" button
    // Reset loading state since we're not loading errors automatically
    this.isLoadingFeedRunErrors = false;

    // Add click event listener to close dropdown when clicking outside
    document.addEventListener('click', this.handleOutsideClick);
  }

  updated() {
    console.log('🔍 FeedDetail component UPDATED');
    console.log('🔍 Updated - feedRunErrors length:', this.feedRunErrors ? this.feedRunErrors.length : 0);
    console.log('🔍 Updated - feedRunErrors isArray:', Array.isArray(this.feedRunErrors));
  }

  beforeDestroy() {
    // Remove event listener when component is destroyed
    document.removeEventListener('click', this.handleOutsideClick);
  }

  /**
   * Handle clicks outside the dropdown to close it
   */
  handleOutsideClick(event: MouseEvent) {
    const dropdown = this.$refs.downloadDropdown as HTMLElement;
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.closeDownloadDropdown();
    }
  }

  /**
   * Toggle the download dropdown visibility
   */
  toggleDownloadDropdown() {
    const dropdown = this.$refs.downloadDropdown as HTMLElement;
    if (dropdown) {
      dropdown.classList.toggle('tw-hidden');
    }
  }

  /**
   * Close the download dropdown
   */
  closeDownloadDropdown() {
    const dropdown = this.$refs.downloadDropdown as HTMLElement;
    if (dropdown) {
      dropdown.classList.add('tw-hidden');
    }
  }

  goBackToFeeds() {
    this.$router.push({ name: 'dataFeedsV2' });
  }

  get useDataCoreV2() {
    return (
      this.checkFeatureFlag('import-v3', this.$store.getters.features) ||
      this.checkFeatureFlag('data-core-v2', this.$store.getters.features)
    );
  }

  /**
   * Check if there are validation issues with the feed
   */
  hasValidationIssues(): boolean {
    // Check feed runs for errors
    if (this.feedRuns && this.feedRuns.length > 0) {
      return this.feedRuns[0].errorCount > 0;
    }
    return false;
  }

  async loadFeedDetails() {
    this.isLoading = true;
    this.error = null;
    try {
      // Pass the feature flag value to the API manager
      const api = DataApiManager.getInstance(true);
      const resp = await api.handlersFeedhdlFeedHTTPHandlerGet(this.orgId, this.feedId, {
        withCredentials: true,
      });

      if (resp.status === 200) {
        // Handle the feedAggregate structure from the API response
        if (resp.data.feedAggregate) {
          // Map the feedAggregate to our feed object
          // Get feed data from the response's feedAggregate property
          const feedData = resp.data.feedAggregate || {};

          // Create a new object with our expected interface
          // Using type assertion to satisfy TypeScript
          this.feed = {
            // Required feed properties
            feedId: feedData.id || '',
            name: feedData.name || '',
            description: feedData.description || '',
            dataSourceId: feedData.dataSourceId || '',
            cronExpression: feedData.schedule?.cronExpression || '',
            status: feedData.status || '',
            configuration: feedData.configuration || {},
            createdBy: feedData.createdBy || { principalId: '' },
            createdAt: feedData.createdAt || '',
            updatedBy: feedData.updatedBy || { principalId: '' },
            updatedAt: feedData.updatedAt || '',
            orgId: feedData.orgId || this.orgId,
            // Additional required properties
            feature: feedData.feature || '',
            entityType: feedData.entityType || '',
            approvalStatus: feedData.approvalStatus || '',
            knownSchemaId: feedData.knownSchemaId || '',
            immutableDataSourceSchemaHash: feedData.immutableDataSourceSchemaHash || '',
          } as any; // Use type assertion to avoid TypeScript errors
        } else {
          // Fall back to the old structure if feedAggregate is not present
          // Create a feed object with default values for all required properties
          this.feed = {
            // Required feed properties with fallbacks
            feedId: this.feedId, // Use the feedId from the route params
            name: '',
            description: '',
            dataSourceId: '',
            cronExpression: '',
            status: '',
            configuration: {},
            createdBy: { principalId: '' },
            createdAt: '',
            updatedBy: { principalId: '' },
            updatedAt: '',
            orgId: this.orgId,
            // Additional required properties with defaults
            feature: '',
            entityType: '',
            approvalStatus: '',
            knownSchemaId: '',
            immutableDataSourceSchemaHash: '',
          } as any; // Use type assertion to avoid TypeScript errors
        }

        // Load recent feed runs directly instead of going through sync summary
        await this.loadRecentFeedRuns();

        // We no longer call the sync summary or validation endpoints - all error information comes from feed runs
      } else {
        this.error = `Error loading feed details: ${resp.statusText || 'Unknown error'}`;
      }
    } catch (err) {
      console.error('Error loading feed details:', err);
      this.error = `Error loading feed details: ${(err as Error).message || 'Unknown error'}`;
    } finally {
      this.isLoading = false;
    }
  }

  // loadValidationStatus method removed - we no longer call the validation endpoint

  /**
   * Format row data for display
   * If it's a JSON string, parse and pretty print it
   * Otherwise return as is
   */
  formatRowData(rowData: string | object): string {
    if (typeof rowData === 'string') {
      try {
        // Try to parse and pretty print JSON
        const parsed = JSON.parse(rowData);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        // If parsing fails, return as is
        return rowData;
      }
    } else if (typeof rowData === 'object') {
      // If it's already an object, stringify it
      return JSON.stringify(rowData, null, 2);
    }
    return String(rowData);
  }

  /**
   * Get the download link for feed data export
   * @param filter Optional filter for the data (e.g., 'synced', 'unsynced', 'error')
   */
  async getDownloadLink(filter?: string): Promise<string | null> {
    try {
      // Pass the feature flag value to the API manager
      const api = DataApiManager.getInstance(true);

      console.log(`Getting download link for feed data with filter: ${filter || 'all'}`);

      // Call the API to get a download link
      const resp = await api.handlersFeedrunhdlFeedRunHandlerGetFeedRunDataDownloadLink(
        this.orgId,
        this.feedId,
        'latest', // Use the latest feed run
        filter || '', // Optional filter
        { withCredentials: true }
      );

      // Log the response to see the actual structure
      console.log('Download link response:', resp.data);

      if (resp.status === 200 && resp.data) {
        // Access the download link using the correct property name
        const downloadLink = resp.data.link;
        console.log('Generated download link successfully');
        return downloadLink || null;
      } else {
        console.error('Error generating download link:', resp.statusText || 'Unknown error');
        return null;
      }
    } catch (err) {
      console.error('Error getting download link:', err);
      return null;
    }
  }

  /**
   * Download feed run data for a specific feed run ID
   * @param feedRunId The ID of the feed run to download data for
   * @param filter Optional filter for the data (e.g., 'error', 'synced', 'unsynced')
   */
  async downloadFeedRunData(feedRunId: string, filter?: string) {
    if (!feedRunId) {
      this.$toasted.error('Feed run ID is required for download');
      return;
    }

    this.isDownloading = true;

    try {
      const api = DataApiManager.getInstance(true);

      // Use axios directly to get a blob response
      const resp = await axios.get(`/api/v1/orgs/${this.orgId}/feeds/${this.feedId}/runs/${feedRunId}/data`, {
        withCredentials: true,
        responseType: 'blob', // Set response type to blob for file download
        params: {
          filter: filter || '', // Add filter parameter if provided
          limit: 10000, // Set a high limit
        },
      });

      if (resp.status === 200) {
        // Create a download link for the blob
        const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `feed-run-data-${this.feedId}-${feedRunId}-${filter || 'all'}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        this.$toasted.error('Error downloading feed run data');
      }
    } catch (error: any) {
      // Type assertion for error
      console.error('Error downloading feed run data:', error);

      // Get error message safely
      const errorMessage = error?.response?.data?.message || error?.message || 'Unknown error';

      // Use this.$toasted which is properly typed
      this.$toasted.error(`Error downloading feed run data: ${errorMessage}`);
    } finally {
      this.isDownloading = false;
    }
  }

  async loadDataSources() {
    this.isLoadingDataSource = true;
    try {
      // Pass the feature flag value to the API manager
      const ds = DataApiManager.getInstance(true);
      const resp = await ds.handlersDatasourcehdlDataSourceHTTPHandlerList(this.orgId, undefined, undefined, {
        withCredentials: true,
      });

      if (resp.status === 200) {
        this.dataSources = resp.data.items || [];
      }
    } catch (err) {
      console.error('Error loading data sources:', err);
    } finally {
      this.isLoadingDataSource = false;
    }
  }

  getDataSourceName(dataSourceId: string): string {
    if (!dataSourceId) return 'N/A';
    if (this.dataSources && this.dataSources.length > 0) {
      const item = this.dataSources.filter((item: { id: string }) => item.id === dataSourceId)[0];
      return item ? item.name : dataSourceId;
    }
    return dataSourceId;
  }

  standardizeFrequency(frequency: string): string {
    if (!frequency) {
      return 'Manual';
    }

    switch (frequency) {
      case '0 0 * * *':
        return 'Nightly';
      case '0 0 1 * *':
        return 'Monthly';
      case '0 0 * * 0':
        return 'Weekly';
      default:
        return frequency;
    }
  }

  async startSyncFeed() {
    if (!this.feed) return;

    this.isStartFeedLoading = true;
    try {
      // Pass the feature flag value to the API manager
      const api = DataApiManager.getInstance(true);
      // First, initiate a manual run to get a feedRunId
      const initResp = await api.handlersFeedrunhdlFeedRunHandlerInitManualRun(this.orgId, this.feedId, false, {
        withCredentials: true,
      });

      if (initResp.status === 200 && initResp.data?.feedRunId) {
        const feedRunId = initResp.data.feedRunId;

        // Then directly start the sync without preview
        // API method signature has changed - now accepts a boolean instead of options object
        const syncResp = await api.handlersFeedrunhdlFeedRunHandlerStartSync(
          this.orgId,
          this.feedId,
          feedRunId,
          false,
          {
            withCredentials: true,
          }
        );

        if (syncResp.status === 200 || syncResp.status === 204) {
          this.showSuccessSnackbar(`Feed "${this.feed.name}" started successfully, Execution ID: ${feedRunId}`);
        } else {
          this.showErrorSnackbar(`Unable to start feed: ${feedRunStartErrorMessage(syncResp)}`);
        }
      } else {
        this.showErrorSnackbar(`Unable to initialize feed run: ${feedRunStartErrorMessage(initResp)}`);
      }
    } catch (err) {
      console.error('Error starting feed sync:', err);
      this.showErrorSnackbar(`Unable to start feed: ${(err as Error).message || 'Unknown error'}`);
    } finally {
      this.isStartFeedLoading = false;
    }
  }

  editFeed() {
    if (!this.feed) return;
    this.$router.push({ name: 'FeedEdit', params: { id: this.feedId } });
  }

  confirmDeleteFeed() {
    this.showDeleteModal = true;
  }

  async deleteFeed() {
    if (!this.feed) return;

    this.isDeleting = true;
    try {
      // Pass the feature flag value to the API manager
      const ds = DataApiManager.getInstance(true);
      const resp = await ds.handlersFeedhdlFeedHTTPHandlerDelete(this.orgId, this.feedId, { withCredentials: true });

      if (resp.status === 200) {
        this.showSuccessSnackbar(`Feed "${this.feed.name}" deleted successfully`);
        this.showDeleteModal = false;
        // Navigate back to feeds list
        this.$router.push({ name: 'dataFeedsV2' });
      } else {
        this.showErrorSnackbar(`Error deleting feed: ${resp.statusText || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Error deleting feed:', err);
      this.showErrorSnackbar(`Error deleting feed: ${(err as Error).message || 'Unknown error'}`);
    } finally {
      this.isDeleting = false;
    }
  }

  async loadRecentFeedRuns() {
    this.isLoadingFeedRuns = true;
    try {
      // Pass the feature flag value to the API manager
      const api = DataApiManager.getInstance(true);
      const resp = await api.handlersFeedrunhdlFeedRunHandlerListRuns(
        this.orgId,
        this.feedId,
        undefined, // filterFeedRunId
        undefined, // filterArchived
        undefined, // filterPendingApproval
        undefined, // startedEarlierThanSEC
        undefined, // startedLaterThanSEC
        undefined, // pageToken
        5, // pageSize - get 5 most recent runs
        { withCredentials: true } // Request options
      );

      if (resp.status === 200 && resp.data.items) {
        // Filter out feed runs with status "initializing"
        this.feedRuns = resp.data.items.filter((run: any) => run.status !== 'initializing');
      } else {
        console.error('Error loading feed runs:', resp.statusText || 'Unknown error');
      }
    } catch (err) {
      console.error('Error loading feed runs:', err);
      // Don't set error state, as this is a secondary request
    } finally {
      this.isLoadingFeedRuns = false;
    }
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return 'N/A';

    try {
      // Check if the date string already has timezone information
      const hasTimezone =
        dateString.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(dateString) || /[+-]\d{4}$/.test(dateString);

      // If no timezone info, assume UTC by appending 'Z'
      const normalizedDateString = hasTimezone ? dateString : `${dateString}Z`;

      // Parse the date string with proper timezone handling
      const date = new Date(normalizedDateString);

      // Use a more explicit date formatting approach
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = monthNames[date.getMonth()];
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();

      // Format time with AM/PM
      let hours = date.getHours();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours || 12; // the hour '0' should be '12'
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      const time = `${hours}:${minutes}:${seconds} ${ampm}`;

      // Return in a clear format that avoids misinterpretation
      return `${month} ${day}, ${year} at ${time}`;
    } catch (e) {
      console.error('Error formatting date:', e);
      return dateString;
    }
  }

  // Removed duplicate formatRowData function

  /**
   * Format a configuration object for display
   */
  formatConfiguration(config: any): string {
    if (!config) return 'None';
    try {
      return JSON.stringify(config, null, 2);
    } catch (e) {
      return 'Invalid Configuration';
    }
  }

  /**
   * Check if a status indicates the feed run is completed
   */
  isCompleteStatus(status: string | undefined): boolean {
    if (!status) return false;

    // Normalize status to uppercase for consistent comparison
    const normalizedStatus = status.toUpperCase();
    return ['COMPLETED', 'COMPLETE'].includes(normalizedStatus);
  }

  /**
   * Download feed run data for a specific feed run ID
   * @param feedRunId The ID of the feed run to download data for
   * @param filter Optional filter for the data (e.g., 'error', 'synced', 'unsynced')
   */
  // First implementation of downloadFeedRunData removed to fix duplicate function error

  statusClass(status: string): Record<string, boolean> {
    if (!status) return { 'tw-text-gray-800': true };

    // Normalize status to uppercase for consistent comparison
    const normalizedStatus = status.toUpperCase();

    return {
      'tw-px-2 tw-inline-flex tw-text-xs tw-leading-5 tw-font-semibold tw-rounded-full': true,
      'tw-bg-green-100 tw-text-green-800': ['COMPLETED', 'COMPLETE'].includes(normalizedStatus),
      'tw-bg-yellow-100 tw-text-yellow-800': normalizedStatus === 'RUNNING',
      'tw-bg-red-100 tw-text-red-800': normalizedStatus === 'FAILED',
      'tw-bg-gray-100 tw-text-gray-800': !['COMPLETED', 'COMPLETE', 'RUNNING', 'FAILED'].includes(normalizedStatus),
    };
  }

  /**
   * Returns the CSS classes for a status badge with more detailed status handling
   */
  statusBadgeClass(status: string): string {
    if (!status) return 'tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-rounded tw-bg-gray-100 tw-text-gray-800';

    // Convert to lowercase for case-insensitive comparison
    const normalizedStatus = status.toLowerCase();

    // Base classes for all badges
    const baseClasses = 'tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-rounded';

    if (normalizedStatus.includes('completed') && normalizedStatus.includes('error')) {
      return `${baseClasses} tw-bg-orange-100 tw-text-orange-800`; // Completed with errors
    } else if (normalizedStatus.includes('complete') || normalizedStatus === 'sync') {
      return `${baseClasses} tw-bg-green-100 tw-text-green-800`; // Success
    } else if (normalizedStatus === 'running' || normalizedStatus === 'in_progress') {
      return `${baseClasses} tw-bg-blue-100 tw-text-blue-800`; // In progress
    } else if (normalizedStatus === 'failed' || normalizedStatus.includes('error')) {
      return `${baseClasses} tw-bg-red-100 tw-text-red-800`; // Failed
    } else if (normalizedStatus === 'pending' || normalizedStatus === 'queued') {
      return `${baseClasses} tw-bg-yellow-100 tw-text-yellow-800`; // Pending
    } else {
      return `${baseClasses} tw-bg-gray-100 tw-text-gray-800`; // Default
    }
  }

  /**
   * Format status string for display
   */
  formatStatus(status: string): string {
    if (!status) return 'Unknown';

    // Convert to lowercase for case-insensitive comparison
    const normalizedStatus = status.toLowerCase();

    // Format the status for display
    if (normalizedStatus === 'completed_with_errors') {
      return 'Completed with Errors';
    } else if (normalizedStatus.includes('complete')) {
      return 'Completed';
    } else if (normalizedStatus === 'running' || normalizedStatus === 'in_progress') {
      return 'Running';
    } else if (normalizedStatus === 'failed') {
      return 'Failed';
    } else if (normalizedStatus === 'sync') {
      return 'Synced';
    } else {
      // Capitalize first letter of each word
      return status
        .replace(/_/g, ' ')
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  }
}
